"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.childrenMover = function (type) {
    var conditionResolver = function (child, isInclude) {
        var condition = child && child.type === type;
        return isInclude ? condition : !condition;
    };
    var childResolver = function (_a) {
        var isInclude = _a.isInclude;
        return function (children) {
            return React.Children.map(children, function (child) { return (conditionResolver(child, isInclude) ? child : null); });
        };
    };
    return {
        include: childResolver({ isInclude: true }),
        exclude: childResolver({ isInclude: false })
    };
};
//# sourceMappingURL=children-mover.js.map